export enum EntityDisplayed {
    Component = 0,
    SUA = 1,
    Reference = 2,
    SuaReference = 3,
    UnitOperation = 4
  }
  